const { $ } = window;

export function initPopup(menuClass) {
  $(`${menuClass} .scroll-menu [data-btn]`).on('click', (e) => {
    const btn = $(e.target).attr('data-btn');
    $(e.target).toggleClass('active');
    $(`${menuClass} .pop-up[data-pop]`).not(`.pop-up[data-pop=${btn}]`).hide();
    $(`${menuClass} .scroll-menu [data-btn]`).not(`.scroll-menu [data-btn=${btn}]`).removeClass('active');
    $(`${menuClass} .pop-up[data-pop=${btn}]`).fadeToggle(300);
  });
  // 儲存
  $(`${menuClass} .pop-up a.save`).click(function save() {
    const popup = $(this).closest('.pop-up').attr('data-pop');
    const checked = $(`${menuClass} [data-pop=${popup}] input:checked`).length;

    // 判斷 checkbox 是否選取
    if (checked !== 0) {
      $(`${menuClass} .scroll-menu [data-btn=${popup}]`).addClass('checked');
    } else {
      $(`${menuClass} .scroll-menu [data-btn=${popup}]`).removeClass('checked');
    }

    $(this).parents('.pop-up').fadeOut(300);
    $(`${menuClass} .scroll-menu [data-btn=${popup}]`).removeClass('active');

    // 判斷儲存篩選狀態
    const checkedBox = $('.scroll-menu a.checked').length;
    if (checkedBox > 0) {
      $(`${menuClass} .remove-all`).show();
    } else {
      $(`${menuClass} .remove-all`).hide();
    }
  });
  // 清除
  $(`${menuClass} .pop-up input[type="checkbox"]`).change(function checkL() {
    const checkLegth = $(this).closest('.pop-up').find('input[type="checkbox"]:checked').length;
    console.log(checkLegth);
    if (checkLegth > 0) {
      $(this).closest('.pop-up').find('.remove').removeClass('disabled');
    } else {
      $(this).closest('.pop-up').find('.remove').addClass('disabled');
    }
  });
  $(`${menuClass} .pop-up a.remove`).click(function remove() {
    const popup = $(this).closest('.pop-up').attr('data-pop');
    $(this).addClass('disabled');

    $(`${menuClass} .pop-up[data-pop=${popup}]`)
      .find('input[type="checkbox"]')
      .prop('checked', false);
  });
  // 清除篩選 all
  $(`${menuClass} .remove-all`).click(() => {
    $(`${menuClass} .remove-all`).hide();
    $(`${menuClass} .scroll-menu [data-btn]`).removeClass('checked');
    $(`${menuClass} .select-block .pop-up`)
      .find('input[type="checkbox"]')
      .prop('checked', false);
    // 還原顯示全部&排序
    setTimeout(() => {
      $(`${menuClass} .pop-up a.remove`).addClass('disabled');
    }, 100);
  });

  // 隱藏
  $(document).on('click', (e) => {
    const dataBtn = $(`${menuClass} [data-btn]`);
    const con = $(`${menuClass} .pop-up`);
    if (!con.is(e.target) && !dataBtn.is(e.target) && con.has(e.target).length === 0 && dataBtn.has(e.target).length === 0) {
      $(`${menuClass} .pop-up`).fadeOut();
      $(`${menuClass} [data-btn].active`).removeClass('active');
    }
  });
}

export default {
  initPopup,
};
